import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ProjectsComponent }   from './projects/projects.component';
import { CalenderComponent }   from './calender.component';
import { ProjectDetailComponent} from './projects/project-detail.component';

const routes: Routes = [
  { path: '', redirectTo: '/projects', pathMatch: 'full' },
  { path: 'projects',  component: ProjectsComponent },
  { path: 'calender',  component: CalenderComponent },
  { path: 'project/:id', component: ProjectDetailComponent}];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /Library/WebServer/Documents/task-manager/src/app/app-routing.module.ts